import {RegionType} from "@pg-rp/common-types";

export const regionsTypesWithForSalePhrase = [RegionType.CITY, RegionType.TOWN, RegionType.DISTRICT, RegionType.NEIGHBORHOOD];
